import { CSSProperties } from 'react';

import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

type ConditionalLinkProps = {
  link?: string | boolean;
  style?: CSSProperties;
  children: any;
}
const ConditionalLink = ({
  link, style, children,
}: ConditionalLinkProps) => {
  if (link) {
    return (
      <Link to={link as string} onClick={(e: any) => e.stopPropagation()}>
        <Button
          color="secondary"
          style={{
            ...style,
            textTransform: 'none',
          }}
        >
          { children }
        </Button>
      </Link>
    );
  }
  return (
    <>
      { children }
    </>
  );
};

export default ConditionalLink;
